import 'jquery';
import { FTScroller } from 'ftscroller';
import * as utils  from './utils.js';

export class Lists {
    /**
    * DEPRECATION NOTICE:
    *
    * This function has been publicly deprecated since Unify 3.0.0.
    * See the release notes: https://unifydeveloperguide.soderbergpartners.se/ReleaseNotes/Ui
    */
    injectHorizontalScroll(selector) {

        var lists;

        if (selector) {
            lists = $('.unify-ticker' + selector);
        } else {
            lists = $('.unify-ticker');
        }

        var that = this;
        lists.each(function (idx, elTicker) {
            that._addScrollerToTicker(elTicker);
        });
    }

    _addScrollerToTicker(elTicker) {
        var qTicker = $(elTicker);

        var qListItems = qTicker.children('.unify-ticker__item');
        qListItems.remove();


        var elButtonRight = document.createElement('button');
        var elButtonLeft = document.createElement('button');
        var elButtonLeftAnchor = document.createElement('div');

        $(elButtonRight).addClass('unify-button-carousel unify-ticker-button-right');
        $(elButtonLeft).addClass('unify-button-carousel unify-ticker-button-left');
        $(elButtonLeftAnchor).addClass('unify-ticker-button-left-anchor');
        $(elButtonLeftAnchor).append(elButtonLeft);

        qTicker.append(elButtonLeftAnchor);

        var elScrollerWrapper = document.createElement('div');
        var elItemWrapper = document.createElement('div');

        var qScrollerWrapper = $(elScrollerWrapper);
        var qItemWrapper = $(elItemWrapper);

        qScrollerWrapper.addClass('unify-ticker-scrollerwrapper');
        qItemWrapper.addClass('unify-ticker-itemwrapper');

        qItemWrapper.append(qListItems);

        qScrollerWrapper.append(qItemWrapper);

        qTicker.append(qScrollerWrapper);

        var ftscroller = new FTScroller(elScrollerWrapper, {
            scrollingY: false,
            scrollbars: false,
            bouncing: false,
            updateOnWindowResize: true,
            disabledInputMethods: { scroll: true }
        });

        /* Appended after the creation of the FTScroller, so it stays outside the scroller */
        qScrollerWrapper.append(elButtonRight);


        var pageWidth = qScrollerWrapper.outerWidth();
        var buttonScrollDuration = 1400;

        $(elButtonRight).on('click', function () {
            ftscroller.scrollBy(pageWidth, 0, buttonScrollDuration);
        });
        $(elButtonLeft).on('click', function () {
            ftscroller.scrollBy(-pageWidth, 0, buttonScrollDuration);
        });

        utils.onFTScrollerScrollabilityChange(ftscroller, function (canScrollRight, canScrollLeft) {
            if (canScrollRight) {
                qTicker.addClass('unify-ticker-can-scroll-right');
            } else {
                qTicker.removeClass('unify-ticker-can-scroll-right');
            }

            if (canScrollLeft) {
                qTicker.addClass('unify-ticker-can-scroll-left');
            } else {
                qTicker.removeClass('unify-ticker-can-scroll-left');
            }
        });
    }
}
